import React from "react";
import { IconButton, Box, Tooltip } from "@material-ui/core";
import WaterIcon from "@material-ui/icons/InvertColors";

const LocationsControl = ({ open = false, onToggle, top = 88, right = 10 }) => {
  return (
    <Box
      bgcolor="#ffffff"
      boxShadow="0 0 0 2px rgba(0,0,0,.1)"
      borderRadius={4}
      position="absolute"
      zIndex={1}
      top={top}
      right={right}
      display="flex"
      flexDirection="column"
    >
      <Tooltip title="BSEACD Locations">
        <IconButton
          size="small"
          color={open ? "secondary" : "default"}
          onClick={onToggle}
        >
          <WaterIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default LocationsControl;
